/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  AbstractSnapshotFormComponent,
  DateTimeTypes,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  IS_REGION_AU_OR_NZ,
  whenAuOrNzRegion,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { getControlValue, STYLES_FLEX_COLUMN_LAYOUT } from '@gh/core-ui';
import { isNotNil } from '@gh/core-util';
import { find } from 'lodash';
import {
  DrawDetailsPaymentInfo,
  DrawDetailsStage,
  isNotFutureDate,
} from '../../../resources/draw-details.model';

@Component({
  standalone: false,
  selector: 'gh-draw-details-payment-form',
  templateUrl: 'draw-details-payment-form.component.html',
  styles: [STYLES_FLEX_COLUMN_LAYOUT],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawDetailsPaymentFormComponent extends AbstractSnapshotFormComponent<DrawDetailsPaymentInfo> {
  @Input() stages: DrawDetailsStage[];
  @Input() hasInvoice: boolean;

  constructor(private formStateBuilder: FormStateBuilder) {
    super();
  }

  get toDateLabel(): string {
    return IS_REGION_AU_OR_NZ ? 'lbl_to_date_incl_gst' : 'lbl_to_date';
  }

  get contractAmountLabel(): string {
    return IS_REGION_AU_OR_NZ ? 'lbl_ex_gst_dollar' : 'lbl_amount_dollar';
  }

  get progressStage(): Maybe<DrawDetailsStage> {
    const progressDrawRuleStage = getControlValue(this.form.group, 'progressDrawRuleStage');
    return find(this.stages, (stage) => stage.stageNumber === progressDrawRuleStage);
  }

  get hasProgressStage(): boolean {
    return isNotNil(this.progressStage);
  }

  isDateAllowed(date: Date): boolean {
    return isNotFutureDate(date);
  }

  protected buildForm(snapshot: FormStateSnapshot<DrawDetailsPaymentInfo>): FormState<DrawDetailsPaymentInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      snapshot,
      children: {
        contractDrawnAmount: { enabled: false },
        variationsDrawnAmount: { enabled: false },
        totalDrawnAmount: { enabled: false },
        totalPaid: { enabled: false },
        totalCreditNotes: { enabled: false },
        totalBalance: { enabled: false },
        contractAmount: { enabled: false },
        contractAmountWithGst: { visible: whenAuOrNzRegion(), enabled: false },
        contractAmountLenders: { enabled: false },
        accountingDate: {
          required: true,
          type: DateTimeTypes.ShortDate,
          // validators: [(control: AbstractControl) => validateNotFutureDate(control.value)],
        },
        drawRuleId: void 0,
        drawRuleCode: void 0,
        drawRuleName: { enabled: false },
        drawRuleStage: { required: true },
        progressDrawRuleStage: void 0,
      },
    });
  }
}
